import { createReducer } from '@reduxjs/toolkit';
import * as actions from 'store/findProvider/actions';
import { SORT_BY_LAST_NAME } from '../constants';
import { ProviderSearchFilterState } from '../types';
import { createFilters } from '../utils';

export const searchFilterInitialState: ProviderSearchFilterState = {
  hasActiveFilters: false,
  sortBy: SORT_BY_LAST_NAME,
  textName: '',
  locationText: '',
  geoLocation: null,
  activeFilters: createFilters()
};

const searchFilterReducer = createReducer(searchFilterInitialState, {
  [actions.PROVIDER_RESET_SEARCH_FILTER]: () => {
    return {
      ...searchFilterInitialState
    };
  },
  [actions.PROVIDER_SET_SORT_BY]: (state, action) => {
    state.sortBy = action.payload;
  },
  [actions.PROVIDER_SET_TEXT_NAME]: (state, action) => {
    state.textName = action.payload;
  },
  [actions.PROVIDER_SET_TEXT_LOCATION]: (state, action) => {
    state.locationText = action.payload;
  },
  [actions.PROVIDER_SET_GEO_LOCATION]: (state, action) => {
    state.geoLocation = { latitude: action.payload.latitude, longitude: action.payload.longitude };
  },
  [actions.PROVIDER_SET_HAS_ACTIVE_FILTERS]: (state, action) => {
    state.hasActiveFilters = action.payload;
  },
  [actions.SET_ACTIVE_PROVIDER_SEARCH_FILTER]: (state, action) => {
    state.activeFilters = { ...state.activeFilters, ...action.payload };
  }
});

export default searchFilterReducer;
